import * as React from "react";
import {
  List,
  ListItemButton,
  ListItem,
  ListItemIcon,
  ListItemText,
  Collapse,
  Typography,
  Box,
  Divider,
} from "@mui/material";

import { useNavigate } from "react-router";
//
import ExpandMore from "@mui/icons-material/ExpandMore";
import ExpandLess from "@mui/icons-material/ExpandLess";
import StarBorder from "@mui/icons-material/StarBorder";
import ReceiptIcon from "@mui/icons-material/Receipt";
import TextSnippetIcon from "@mui/icons-material/TextSnippet";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined";
import DashboardIcon from "@mui/icons-material/Dashboard";
import SaveAsOutlinedIcon from "@mui/icons-material/SaveAsOutlined";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import RocketLaunchOutlinedIcon from "@mui/icons-material/RocketLaunchOutlined";
import DocumentScannerOutlinedIcon from "@mui/icons-material/DocumentScannerOutlined";

const LeftNavbarLists = ({ open }) => {
  const navigate = useNavigate();
  const [listDropDown, setListDrop] = React.useState({
    open1: false,
    open2: false,
    open3: false,
    open4: false,
    open5: false,
    open6: false,
    open7: false,
    open8: false,
    open9: false,
  });

  const handleClickManage = (button, event) => {
    setListDrop((prev) => {
      let applyChange = {
        open1: false,
        open2: false,
        open3: false,
        open4: false,
        open5: false,
        open6: false,
        open7: false,
        open8: false,
        open9: false,
      };
      applyChange[button] = !prev[button];
      return applyChange;
    });
    event.stopPropagation();
  };

  React.useEffect(() => {
    if (!open) {
      setListDrop({
        open1: false,
        open2: false,
        open3: false,
        open4: false,
        open5: false,
        open6: false,
        open7: false,
        open8: false,
        open9: false,
      });
    }
  }, [open]);

  return (
    <>
      <List>
        <ListItem disablePadding sx={{ display: "block" }}>
          <ListItemButton
            onClick={(event) => handleClickManage("open1", event)}
            label="first"
            key="225"
          >
            <ListItemIcon>
              <HomeOutlinedIcon size="small" />
            </ListItemIcon>
            <ListItemText primary="Dashboards" />
            {listDropDown.open1 ? <ExpandLess /> : <ExpandMore />}
          </ListItemButton>
          <Collapse in={listDropDown.open1} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              <ListItemButton
                onClick={() => {
                  navigate("/");
                }}
                sx={{ pl: 3 }}
              >
                <ListItemIcon>
                  <DashboardIcon />
                </ListItemIcon>
                <ListItemText primary="Dashboard" />
              </ListItemButton>
            </List>
          </Collapse>

          <ListItemButton
            onClick={(event) => handleClickManage("open2", event)}
          >
            <ListItemIcon>
              <DocumentScannerOutlinedIcon />
            </ListItemIcon>
            <ListItemText primary=" Documents " />
            {listDropDown.open2 ? <ExpandLess /> : <ExpandMore />}
          </ListItemButton>
          <Collapse in={listDropDown.open2} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              <ListItemButton
                onClick={() => {
                  navigate("/manage-Documents/repository");
                }}
                sx={{ pl: 3 }}
              >
                <ListItemIcon>
                  <ReceiptIcon />
                </ListItemIcon>
                <ListItemText primary="Repository" />
              </ListItemButton>
              <ListItemButton
                onClick={() => {
                  navigate("/manage-Documents/application");
                }}
                sx={{ pl: 3 }}
              >
                <ListItemIcon>
                  <TextSnippetIcon />
                </ListItemIcon>
                <ListItemText primary="App. Specific" />
              </ListItemButton>

              <ListItemButton
                onClick={() => {
                  navigate("/manage-Documents/purge");
                }}
                sx={{ pl: 3 }}
              >
                <ListItemIcon>
                  <TextSnippetIcon />
                </ListItemIcon>
                <ListItemText primary="Purge" />
              </ListItemButton>
            </List>
          </Collapse>

          <ListItemButton
            onClick={(event) => handleClickManage("open3", event)}
          >
            <ListItemIcon>
              <SaveAsOutlinedIcon />
            </ListItemIcon>
            <ListItemText primary="Templates" />
            {listDropDown.open3 ? <ExpandLess /> : <ExpandMore />}
          </ListItemButton>
          <Collapse in={listDropDown.open3} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              <ListItemButton
                onClick={() => navigate("/manage-Templates")}
                sx={{ pl: 3 }}
              >
                <ListItemIcon>
                  <StarBorder />
                </ListItemIcon>
                <ListItemText primary="All Templates" />
              </ListItemButton>
            </List>
          </Collapse>
          <Typography
            variant="overline"
            display="block"
            gutterBottom
            sx={{ width: "100%", textAlign: "center", marginTop: "1rem" }}
          >
            {open ? "ADMINISTRATION TASKS" : "  "}
          </Typography>
          <Box sx={{ padding: "0 1rem" }}>
            <Divider />
          </Box>

          <ListItemButton
            onClick={(event) => handleClickManage("open4", event)}
          >
            <ListItemIcon>
              <GroupsOutlinedIcon />
            </ListItemIcon>
            <ListItemText primary="Manage Users" />
            {listDropDown.open4 ? <ExpandLess /> : <ExpandMore />}
          </ListItemButton>
          <Collapse
            in={listDropDown.open4}
            timeout="auto"
            unmountOnExit
            onClick={(event) => event.stopPropagation()}
          >
            <List component="div" disablePadding>
              <ListItemButton
                onClick={() => {
                  navigate("/list-Users");
                }}
                sx={{ pl: 3 }}
              >
                <ListItemIcon>
                  <AccountCircleIcon />
                </ListItemIcon>
                <ListItemText primary={"All Users"} />
              </ListItemButton>
            </List>
          </Collapse>

          <ListItemButton
            onClick={(event) => handleClickManage("open5", event)}
          >
            <ListItemIcon>
              <PersonOutlineOutlinedIcon />
            </ListItemIcon>
            <ListItemText primary="Manage Roles" />
            {listDropDown.open5 ? <ExpandLess /> : <ExpandMore />}
          </ListItemButton>
          <Collapse
            in={listDropDown.open5}
            timeout="auto"
            unmountOnExit
            onClick={(event) => event.stopPropagation()}
          >
            <List component="div" disablePadding>
              <ListItemButton
                onClick={() => {
                  navigate("/manage-Roles");
                }}
                sx={{ pl: 3 }}
              >
                <ListItemIcon>
                  <AccountCircleIcon />
                </ListItemIcon>
                <ListItemText primary={"All Roles"} />
              </ListItemButton>
            </List>
          </Collapse>

          <ListItemButton
            onClick={(event) => handleClickManage("open6", event)}
          >
            <ListItemIcon>
              <RocketLaunchOutlinedIcon />
            </ListItemIcon>
            <ListItemText primary="Manage API" />
            {listDropDown.open6 ? <ExpandLess /> : <ExpandMore />}
          </ListItemButton>
          <Collapse
            in={listDropDown.open6}
            timeout="auto"
            unmountOnExit
            onClick={(event) => event.stopPropagation()}
          >
            <List component="div" disablePadding>
              <ListItemButton
                onClick={() => {
                  navigate("/manage-Apis");
                }}
                sx={{ pl: 3 }}
              >
                <ListItemIcon>
                  <AccountCircleIcon />
                </ListItemIcon>
                <ListItemText primary={"All API's"} />
              </ListItemButton>
            </List>
          </Collapse>
          <ListItemButton
            onClick={(event) => handleClickManage("open7", event)}
          >
            <ListItemIcon>
              <RocketLaunchOutlinedIcon />
            </ListItemIcon>
            <ListItemText primary="Manage Rules" />
            {listDropDown.open7 ? <ExpandLess /> : <ExpandMore />}
          </ListItemButton>
          <Collapse
            in={listDropDown.open7}
            timeout="auto"
            unmountOnExit
            onClick={(event) => event.stopPropagation()}
          >
            <List component="div" disablePadding>
              <ListItemButton
                onClick={() => {
                  navigate("/manage-rules");
                }}
                sx={{ pl: 3 }}
              >
                <ListItemIcon>
                  <AccountCircleIcon />
                </ListItemIcon>
                <ListItemText primary={"All Rules"} />
              </ListItemButton>
            </List>
          </Collapse>
        </ListItem>
      </List>
    </>
  );
};
export default LeftNavbarLists;
